import axios from "./api";

const ShafyorService = {

    async searchByName(search) {
       const role = 'Шафёр';
        try {
            const response = await axios.get('/user', {
                params: {
                    search: search,
                    roles: role,
                }
            });
            console.log('shafyors', response.data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting transport list';
        }
    },


    /**
     * data should look like this
     * "data": {
     *     "name": "Ali Valiyev",
     *     "phone": "998901234567",
     *     "email": "ali@example.com",
     *     "role": "Шафёр",
     *   }
     * @param data
     * @returns {Promise<any>}
     */
    async createShafyor(data) {
        const roleForShafyor = 'Шафёр';
        data.role = roleForShafyor;
        try {
            const response = await axios.post('/user', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        }catch (error) {
            throw error.response?.data?.message || 'Error creating shafyor';
        }
    }
}
export default ShafyorService